const pendingData = [
  {
    user: {
      name: "Sam Altman",
      mail: "samaltman123@gmail.com",
    },
    riskLevel: "Medium",
    triggerReason: "IP Change",
    inQueueFor: "4 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "Yes",
      reviewDate: "23 Aug, 2023",
    },
  },
  {
    user: {
      name: "Sameer Choubey",
      mail: "sameer123@gmail.com",
    },
    riskLevel: "High",
    triggerReason: "FIFO",
    inQueueFor: "4 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "No",
      reviewDate: "",
    },
  },
  {
    user: {
      name: "Adarsh Panikar",
      mail: "adarsh@onjuno.com",
    },
    riskLevel: "Low",
    triggerReason: "IP Change",
    inQueueFor: "5 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "No",
      reviewDate: "",
    },
  },
  {
    user: {
      name: "Pratik Shetty",
      mail: "pratik3@gmail.com",
    },
    riskLevel: "High",
    triggerReason: "FIFO",
    inQueueFor: "5 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "Yes",
      reviewDate: "12 Sep, 2023",
    },
  },
  {
    user: {
      name: "Elon Musk",
      mail: "elon@twitterceo.com",
    },
    riskLevel: "Low",
    triggerReason: "FIFO",
    inQueueFor: "5 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "Yes",
      reviewDate: "12 Sep, 2023",
    },
  },
  {
    user: {
      name: "Trina Kundu",
      mail: "trina@onjuno.com",
    },
    riskLevel: "Low",
    triggerReason: "FIFO",
    inQueueFor: "5 days",
    dateAddedOn: "12 Oct, 2023",
    previouslyReviewed: {
      reviewed: "Yes",
      reviewDate: "12 Sep, 2023",
    },
  },
];

export default pendingData;
